import moment from 'moment'

import { IContactEntityActionModel } from '@apps-common/types/portal/contact'

interface IProps {
  action: IContactEntityActionModel
}

export const ContactActionsCard: React.FC<IProps> = ({ action }) => {
  const { note, date, contactName } = action

  const timestamp = moment.utc(date).local().format('ddd Do MMM YY h:mm a')

  return (
    <div className='relative overflow-hidden bg-surface text-text border border-border rounded-[30px] px-[20px] pt-[35px] pb-[15px]'>
      <div className='jost-light flex flex-col gap-[10px]'>
        <div className='absolute top-0 right-0  text-[0.8em] pl-[15px] pr-[20px] py-[2px] rounded-bl-[15px] bg-surface-2'>{timestamp}</div>
        <div className='text-[0.95em] flex items-center justify-between rounded-lg'>
          <div className='pl-[5px]'>Contact</div>
          <div className='bg-surface-2 px-[10px] py-[5px] rounded-lg'>{contactName}</div>
        </div>
        <div className='text-[0.95em] flex flex-col items-start justify-start gap-[5px] rounded-lg'>
          <div className='pl-[5px]'>Action</div>
          <div className='bg-surface-2 border border-border px-[10px] py-[5px] rounded-xl w-full min-h-[50px]'>{note}</div>
        </div>
      </div>
    </div>
  )
}
